export default "__VITE_ASSET__fcc9bf75__"